export default {
	"autoreport": {
		"algoModel": "算法模型",
		"templateCode": "内容模板",
		"emailTitle": "邮件标题",
		"fileType": "附件格式",
		"batchOperationTips": "勾选需要操作的数据",
		"tabPanleName1": "报表信息",
		"daily": "每日",
		"emailValidataMsg1": "邮箱地址不正确",
		"emailValidataMsg2": "邮箱地址已被注册",
		"emailValidataMsg3": "邮箱地址长度不能大于500"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/autoreport/autoreport.js